import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import "../../assets/styles/cards.scss";
import "../../assets/styles/main.scss";
class ResumeCard extends React.Component {
  constructor(props) {
    super(props);
    this.ws = this.props.ws;
    this.state = {
      data: [],
      kpi: {},
      renderKpi: false
    };
    this.data = [];
  }

  getObjectByid = async action => {
    this.state.data = [];
    await this.ws.connect(action).then(response => {
      this.setState({
        data: this.state.data.concat([response])
      });
    });
  };

  async componentDidMount() {
    switch (this.props.customClass) {
      case "inventory":
        await this.getObjectByid("getKpiInventory");
        this.setState({
          kpi: await this.state.data[0].data.totalRow.map(data => {
            return {
              data1: data["# Categorias"],
              data2: data["# Articulos"],
              data3: data["# U. de Negocio"]
            };
          })
        });
        break;
      case "sales":
        await this.getObjectByid("getKpiSales");
        console.log(this.state.data);
        if (this.state.data.length>0) {
          this.setState({
            kpi: await this.state.data[0].data.totalRow.map(data => {
              return {
                data1: data["Venta Año anterior"],
                data2: data["Venta Actual"],
                data3: data["Venta Promedio"]
              };
            })
          });
        }
        break;
      default:
        break;
    }
    this.setState({
      renderKpi: true
    });
    switch (this.props.customClass) {
      case "sale":
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <Row>
        <Card className="col-12 mb-0 border-0">
          <Row>
            <Col className={ `data-block card-cover card-cover__${ this.props.customClass }` }>
              <Row className="align-items-center h-100 py-3 justify-content-center justify-content-sm-start">
                <span className="d-flex flex-column card-cover__title text-white ml-sm-5 pl-sm-5">
                  <span className="is-font-weight--extra-bold">BIENVENIDO</span>
                  <span className={ `is-font-weight--light text-${ this.props.customClass }` }>{ `${this.props.user}` }</span>
                </span>{" "}
                {this.state.kpi[0] ? (
                  <div className="d-flex align-items-end justify-content-center card-cover__circles-wrap mx-auto">
                    <div
                      className={` gradient-circle__${this.props.customClass} circle-1 d-flex align-items-center justify-content-center flex-column rounded-circle`}
                    >
                      <span className="text-white is-h6 is-font-weight--light">Vta. Ant</span>
                      <strong className="text-white is-h6 is-font-weight--bold">
                        {" "}
                        {console.log(this.state.kpi[0].data1)}
                        {this.state.kpi[0].data1}
                      </strong>
                    </div>
                    <div
                      className={` gradient-circle__${this.props.customClass} circle-2 d-flex align-items-center justify-content-center flex-column rounded-circle`}
                    >
                      <span className="text-white is-h6 is-font-weight--light">Venta MTD</span>
                      <strong className="text-white is-h5 is-font-weight--bold">
                        {" "}
                        {this.state.kpi[0].data2}
                      </strong>
                    </div>
                    <div
                      className={` gradient-circle__${this.props.customClass} circle-3 d-flex align-items-center justify-content-center flex-column rounded-circle`}
                    >
                      <span className="text-white is-h6 is-font-weight--light">Venta Prom</span>
                      <strong className="text-white is-h6 is-font-weight--bold">
                        {" "}
                        {this.state.kpi[0].data3}
                      </strong>
                    </div>
                  </div>
                ) : (
                  <h2>Cargando...</h2>
                )}
              </Row>
            </Col>
            <Col md={6} className="image-block d-xs-none"></Col>{" "}
          </Row>
        </Card>
      </Row>
    );
  }
}
export default ResumeCard;
